import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type DeliveryStatus = {
  step: number;
  status_code: string;
  status_label: string;
  description: string;
  isDone: boolean;
  _id: string;
};

type FetchDelivertResponse = {
  _id: string;
  delivery_number: string;
  departure_date: string;
  vehicle_plate_number: string;
  driver_name: string;
  origin_city: string;
  destination_city: string;
  departure_time: string | null;
  estimation_arrival_date: string;
  arrival_date: string | null;
  expenses: [];
  delivery_status: DeliveryStatus[];
  admin_maker: string;
};

interface DelivertState {
  delivery_number: string;
  departure_date: string;
}

const initialState: DelivertState = {
  delivery_number: "",
  departure_date: "",
};

export const deliverySlice = createSlice({
  name: "delivery",
  initialState,
  reducers: {
    setSelectedDeliveryData: (
      state,
      action: PayloadAction<FetchDelivertResponse>,
    ) => {
      const { delivery_number, departure_date } = action.payload;
      state.delivery_number = delivery_number;
      state.departure_date = departure_date;
    },
    clearSelectedDeliveryData: (state) => {
      state.delivery_number = "";
      state.departure_date = "";
    },
  },
});

export const { setSelectedDeliveryData, clearSelectedDeliveryData } =
  deliverySlice.actions;

export default deliverySlice.reducer;
